import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const useIsTeamLeaderOrAdmin = (teamId?: string) => {
  const { me } = useAppData();

  if (!teamId || !me) {
    return false;
  }
  if (me.is_admin) {
    return true;
  }

  return me.teams?.find(team => team.team_id === teamId)?.is_leader ?? false;
};
